var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('b-card', [_c('div', [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Contract List")]), _vm._v(" "), _c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset,
      "isEditHidden": true
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createTemplatesFlag),
      expression: "createTemplatesFlag"
    }]
  }, [_c('ContractTemplateView', {
    attrs: {
      "selectedEditRow": _vm.selectedEditRow
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2376e1e","hasScoped":true}!./src/modules/clientmanagement/views/client/clientlisting/clienteview/contracts/contracts.component.html
// module id = 697
// module chunks = 3